import React, { useEffect, useMemo, useRef } from "react";
import { useControl } from "./controlContext";
// import { useSource } from "./sourceContext";
import { Theme } from "./themes/bootstrap";
import { useSchema } from "./schemaContext";

export function ControlCreator({ content, objectMetadata }) {
  const controls = useControl()
  const ref = useRef(null)
  // const source = useSource()
  const schemas = useSchema()
  const components = useMemo(() => {
    // console.log('contentToControls: schemas, controls', schemas, controls)
    return controls.map((contentBlock, idx) => {
      return mapSchemaOverContent(contentBlock.schema ? schemas.find(sch => sch.name === contentBlock.schema).content : schemas[0].content, contentBlock, idx, objectMetadata)
    })
  }, [schemas, controls, objectMetadata])

  return (
    <div className="control-manager-child-wrapper">
      <div ref={ref} className="control-manager-children">
        {components}
      </div>
    </div>
  )
}

function mapSchemaOverContent(schema, contentToMap, idx, objectMetadata, recursed = false) {
  // console.log('mapSchemaOverContent', schema, contentToMap)
  return schema.map((itm, schIdx) => {
    // console.log('theme', contentToMap, itm, Theme, contentToMap[idx])
    let ControlType = Theme[itm.type]
    let { children: childData, ...props } = itm
    if (childData) {
      props.children = mapSchemaOverContent(childData, contentToMap, idx, objectMetadata, true)
    }
    // console.log('creating control', itm.name, itm.type, props)
    return (
      <ControlType key={`${idx}-${schIdx}`} idx={idx} name={itm.name} objectMetadata={objectMetadata}
        {...props}
      />
    )
  })
}

